import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading, HeroIcon, InnerStepContainer, StepContainer } from '../common.js';
import { useModalStore } from '../../stores/index.js';
import { useMemo } from 'react';
import { CpslButton, CpslText } from '@usecapsule/react-components';
import { ModalStep } from '../../utils/steps.js';
export const AddFundsDone = ({ isSuccess, onClose }) => {
    const setStep = useModalStore(state => state.setStep);
    const onRampPurchase = useModalStore(state => state.onRampPurchase);
    const formatter = useMemo(() => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: (onRampPurchase === null || onRampPurchase === void 0 ? void 0 : onRampPurchase.fiat) || 'USD',
        });
    }, [onRampPurchase === null || onRampPurchase === void 0 ? void 0 : onRampPurchase.fiat]);
    const heading = isSuccess ? 'Transaction Successful' : 'Something Went Wrong';
    const text = isSuccess
        ? `${formatter.format(parseFloat(onRampPurchase === null || onRampPurchase === void 0 ? void 0 : onRampPurchase.fiatQuantity))} is now available in your wallet.`
        : 'No funds were added to your wallet.';
    const buttonText = isSuccess ? 'Done' : 'Try Again';
    return (_jsxs(StepContainer, { children: [_jsx(HeroIcon, { icon: "checkCircleFilled" }), _jsxs(InnerStepContainer, { children: [_jsx(Heading, { variant: "headingS", weight: "bold", children: heading }), _jsx(CpslText, { variant: "bodyS", color: "secondary", children: text })] }), _jsx(CpslButton, { fullWidth: true, onClick: () => {
                    isSuccess ? onClose() : setStep(ModalStep.ADD_FUNDS);
                }, children: buttonText })] }));
};
